import { Controller } from 'stimulus';
import { youtubeVideoId } from '../../../util';

export default class extends Controller {
  static targets = ['thumb'];

  #radio;
  #field;
  #onGroupChange;
  #onFieldInput;

  connect() {
    this.#radio = this.element.querySelector('input[type="radio"]');
    this.#field = this.element.querySelector('input:not([type="radio"]), textarea');
    if (!this.#radio) {
      return;
    }

    this.#onGroupChange = (event) => {
      if (event.target.name === this.#radio.name) {
        this.#selectionChanged();
      }
    };
    this.#scope.addEventListener('change', this.#onGroupChange);

    if (this.#field) {
      this.#onFieldInput = () => this.#refreshThumb();
      this.#field.addEventListener('input', this.#onFieldInput);
    }
  }

  disconnect() {
    this.#scope.removeEventListener('change', this.#onGroupChange);
    this.#field?.removeEventListener('input', this.#onFieldInput);
  }

  select() {
    if (!this.#radio || this.#radio.checked) {
      return;
    }
    this.#radio.checked = true;
    this.#radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  get #scope() {
    return this.element.closest('form') ?? document;
  }

  #selectionChanged() {
    if (!this.#field) {
      return;
    }
    if (this.#radio.checked) {
      this.#field.disabled = false;
      this.#field.focus();
    } else {
      this.#field.disabled = true;
      this.#field.value = '';
    }
    this.#refreshThumb();
  }

  #refreshThumb() {
    if (!this.#field || !this.hasThumbTarget) {
      return;
    }
    const id = this.#radio.checked ? youtubeVideoId(this.#field.value) : null;
    this.thumbTarget.dataset.empty = !id;
    this.thumbTarget.style.backgroundImage = id
      ? `url("https://img.youtube.com/vi/${id}/hqdefault.jpg")`
      : '';
  }
}
